function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEDEF"
    },
    d: "M100.641,0c-14.139,0-25.6,11.461-25.6,25.6v460.8c0,14.139,11.461,25.6,25.6,25.6h375.467 c14.139,0,25.6-11.461,25.6-25.6V85.333L416.375,0H100.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M441.975,85.333h59.733L416.375,0v59.733C416.375,73.872,427.836,85.333,441.975,85.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6CACF"
    },
    d: "M399.308,42.667H75.041v153.6h324.267c4.713,0,8.533-3.821,8.533-8.533V51.2 C407.841,46.487,404.02,42.667,399.308,42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#529E44"
    },
    d: "M382.241,179.2H18.843c-7.602,0-11.41-9.191-6.034-14.567L75.041,102.4L12.809,40.167 C7.433,34.791,11.241,25.6,18.843,25.6h363.398c4.713,0,8.533,3.821,8.533,8.533v136.533 C390.775,175.379,386.954,179.2,382.241,179.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M185.975,76.8h-34.133c-4.713,0-8.533,3.821-8.533,8.533s3.821,8.533,8.533,8.533h8.533v42.667 c0,4.713,3.821,8.533,8.533,8.533c4.713,0,8.533-3.821,8.533-8.533V93.867h8.533c4.713,0,8.533-3.821,8.533-8.533 S190.688,76.8,185.975,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M305.441,76.8h-34.133c-4.713,0-8.533,3.821-8.533,8.533s3.821,8.533,8.533,8.533h8.533v42.667 c0,4.713,3.821,8.533,8.533,8.533s8.533-3.821,8.533-8.533V93.867h8.533c4.713,0,8.533-3.821,8.533-8.533 S310.155,76.8,305.441,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M250.442,78.234c-3.92-2.615-9.219-1.555-11.834,2.367l-9.967,14.95l-9.967-14.95 c-2.614-3.921-7.913-4.98-11.834-2.367c-3.921,2.614-4.981,7.911-2.367,11.834l13.913,20.866l-13.911,20.867 c-2.39,3.585-1.671,8.551,1.651,11.301c3.851,3.187,9.779,2.321,12.549-1.835l9.967-14.95l9.967,14.95 c2.77,4.156,8.698,5.022,12.549,1.835c3.323-2.75,4.042-7.715,1.651-11.301l-13.913-20.867l13.911-20.867 C255.423,86.145,254.363,80.847,250.442,78.234z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6CACF"
    },
    d: "M331.041,460.8H160.375c-4.713,0-8.533-3.821-8.533-8.533V230.4c0-4.713,3.821-8.533,8.533-8.533 h170.667c4.713,0,8.533,3.821,8.533,8.533v221.867C339.575,456.979,335.754,460.8,331.041,460.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M173.175,443.733c-2.356,0-4.267-1.91-4.267-4.267v-217.6h-8.533c-4.713,0-8.533,3.821-8.533,8.533 v221.867c0,4.713,3.821,8.533,8.533,8.533h170.667c4.713,0,8.533-3.821,8.533-8.533v-8.533H173.175z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B848F"
    },
    d: "M296.908,273.067h-102.4c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h102.4 c4.713,0,8.533,3.821,8.533,8.533C305.441,269.246,301.621,273.067,296.908,273.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B848F"
    },
    d: "M296.908,324.267h-102.4c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h102.4 c4.713,0,8.533,3.821,8.533,8.533C305.441,320.446,301.621,324.267,296.908,324.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B848F"
    },
    d: "M296.908,375.467h-102.4c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h102.4 c4.713,0,8.533,3.821,8.533,8.533S301.621,375.467,296.908,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B848F"
    },
    d: "M296.908,426.667h-102.4c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h102.4 c4.713,0,8.533,3.821,8.533,8.533S301.621,426.667,296.908,426.667z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC44F"
    },
    d: "M388.971,247.2L250.189,385.982l-20.753,45.658c-3.263,7.178,4.122,14.562,11.299,11.299 l45.658-20.753l138.782-138.782c3.332-3.332,3.332-8.736,0-12.068L401.039,247.2C397.707,243.868,392.303,243.868,388.971,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C9FE8"
    },
    d: "M286.393,422.186l-36.204-36.204L388.971,247.2c3.332-3.332,8.736-3.332,12.068,0l24.135,24.135 c3.332,3.332,3.332,8.736,0,12.068L286.393,422.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M401.039,307.54l-36.204-36.204l24.135-24.135c3.332-3.332,8.736-3.332,12.068,0l24.135,24.135 c3.332,3.332,3.332,8.736,0,12.068L401.039,307.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC44F"
    },
    d: "M229.436,431.639l20.753-45.658l36.204,36.204l-45.658,20.753 C233.557,446.202,226.173,438.817,229.436,431.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#427FC9"
    },
    d: "M425.175,283.404c3.332-3.332,3.332-8.736,0-12.068l-6.034-6.034L274.325,410.117l12.068,12.068 L425.175,283.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1A7AF"
    },
    d: "M425.175,283.404c3.332-3.332,3.332-8.736,0-12.068l-6.034-6.034l-30.17,30.17l12.068,12.068 L425.175,283.404z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F79F4D"
    },
    points: "274.325,410.117 242.144,442.299 286.393,422.186 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.e118d8295d46eb28c7186a1894bff6c7.svg";
export { ForwardRef as ReactComponent };